// SEO landing pages: course+city pages and one page per Vidarbha district (for
// hostel/outstation students). Consistent NAP (name/address/phone) is reused in
// LocalBusiness schema on every page to match the Google Business Profile.

export const NAP = {
  name: "The Rankers Academy",
  streetAddress: "Plot 10, Buty Layout, RPTS Road, Laxmi Nagar",
  locality: "Nagpur",
  region: "Maharashtra",
  postalCode: "440022",
  country: "IN",
  phone: "+91-7219074788",
  phoneDisplay: "721 907 4788",
  altPhone: "+91-8329100890",
  email: "therankersacademyngp@gmail.com",
  url: "https://therankersacademy.in",
  geo: { lat: 21.1335, lng: 79.0882 },
};

const PROGRAMMES = [
  { title: "JEE (Main + Advanced)", desc: "Two-year & foundation tracks for Classes 11-12 and droppers, taught by VNIT alumni." },
  { title: "NEET-UG", desc: "Full Physics, Chemistry & Biology coverage with NCERT-first strategy and daily MCQ drills." },
  { title: "MHT-CET", desc: "State-CET focused batches with PCM/PCB, speed tests and percentile optimisation." },
  { title: "Foundation (Class 8-10)", desc: "Early Olympiad + board foundation that makes the JEE/NEET jump effortless." },
];

// ---- Course + city pages ----
const COURSE_PAGES = [
  {
    path: "/jee-coaching-in-nagpur",
    exam: "JEE",
    h1: "JEE Coaching in Nagpur",
    title: "Best JEE Coaching in Nagpur | The Rankers Academy (VNIT Alumni)",
    metaDescription: "Looking for JEE Main & Advanced coaching in Nagpur? The Rankers Academy in Laxmi Nagar is founded and taught by VNIT Nagpur alumni — daily micro-tests, small batches, proven IIT results.",
    kicker: "IIT-JEE · Main + Advanced",
    intro: [
      "The Rankers Academy is a dedicated JEE coaching institute in Nagpur, founded by VNIT Nagpur alumni who teach every batch themselves — no surrogate junior faculty. Our Laxmi Nagar centre runs focused JEE Main and Advanced batches for Classes 11, 12 and droppers.",
      "What sets us apart is our daily micro-test system (DMT): students take a short, timed test every single day, so concepts are revised and rank is built brick by brick instead of cramming before exams.",
    ],
    highlights: [
      "Taught directly by VNIT Nagpur alumni with 12+ years of JEE mentorship",
      "Daily micro-tests (DMT) + dedicated DPPs for every chapter",
      "Small, focused batches at our Laxmi Nagar head centre",
      "Recent result: IIT (ISM) Dhanbad selection — JEE Advanced 2026",
    ],
    faqs: [
      { q: "Where is your JEE coaching centre in Nagpur?", a: "Our head centre is at Plot 10, Buty Layout, RPTS Road, Laxmi Nagar, Nagpur — about 200m from Mate Square." },
      { q: "Do the directors actually teach JEE batches?", a: "Yes. Er. Santosh Yadav and the founding team teach the core JEE Physics/Maths themselves; we do not outsource teaching to junior faculty." },
      { q: "Do you offer a demo class before joining?", a: "Yes, you can book a free demo class to experience the teaching before you enrol." },
    ],
  },
  {
    path: "/neet-coaching-in-nagpur",
    exam: "NEET",
    h1: "NEET Coaching in Nagpur",
    title: "Best NEET Coaching in Nagpur | The Rankers Academy",
    metaDescription: "NEET-UG coaching in Nagpur at The Rankers Academy, Laxmi Nagar. NCERT-first Physics, Chemistry & Biology, daily micro-tests and small batches by experienced mentors. Book a free demo.",
    kicker: "NEET-UG · Medical",
    intro: [
      "The Rankers Academy offers structured NEET-UG coaching in Nagpur from its Laxmi Nagar head centre. Our Biology, Physics and Chemistry programme is built NCERT-first, the way NEET actually rewards.",
      "Our daily micro-test (DMT) system keeps every chapter revised and exam-ready, while small batches mean each aspirant gets real mentor attention — not a crowded hall.",
    ],
    highlights: [
      "NCERT-first NEET strategy with full PCB coverage",
      "Daily micro-tests + weekly full-syllabus practice",
      "Small batches with personal doubt-solving",
      "Disciplined, distraction-free Laxmi Nagar campus",
    ],
    faqs: [
      { q: "Where is your NEET coaching in Nagpur located?", a: "At Plot 10, Buty Layout, RPTS Road, Laxmi Nagar, Nagpur 440022 — about 200m from Mate Square." },
      { q: "Do you cover full NEET Biology, Physics and Chemistry?", a: "Yes — the programme covers the complete NEET-UG syllabus for all three subjects, NCERT-first." },
      { q: "Can I attend a free demo?", a: "Yes, book a free demo class to experience our NEET teaching first-hand." },
    ],
  },
  {
    path: "/mht-cet-classes-nagpur",
    exam: "MHT-CET",
    h1: "MHT-CET Classes in Nagpur",
    title: "MHT-CET Classes in Nagpur | The Rankers Academy",
    metaDescription: "MHT-CET coaching classes in Nagpur at The Rankers Academy, Laxmi Nagar. PCM & PCB batches, speed tests and percentile-focused preparation for Maharashtra's CET. Book a free demo.",
    kicker: "MHT-CET · State CET",
    intro: [
      "The Rankers Academy runs MHT-CET classes in Nagpur designed around Maharashtra's state CET pattern — speed, accuracy and percentile. Our Laxmi Nagar centre offers both PCM and PCB tracks.",
      "With daily micro-tests tuned to the CET's time pressure and a NCERT + state-board aligned syllabus, students build the speed and percentile that top CET colleges demand.",
    ],
    highlights: [
      "PCM and PCB MHT-CET batches",
      "CET-style speed tests and percentile tracking",
      "Aligned to Maharashtra State Board + NCERT",
      "Taught by VNIT Nagpur alumni mentors",
    ],
    faqs: [
      { q: "Where are your MHT-CET classes in Nagpur?", a: "At Plot 10, Buty Layout, RPTS Road, Laxmi Nagar, Nagpur — around 200m from Mate Square." },
      { q: "Do you offer both PCM and PCB for MHT-CET?", a: "Yes, we run both engineering (PCM) and pharmacy/medical (PCB) MHT-CET tracks." },
      { q: "Is there a free demo class?", a: "Yes, you can book a free demo before enrolling." },
    ],
  },
];

// ---- Vidarbha district pages (outstation / hostel students coming to Nagpur) ----
const DISTRICTS = [
  { name: "Wardha", km: 75 },
  { name: "Bhandara", km: 65 },
  { name: "Gondia", km: 155 },
  { name: "Chandrapur", km: 150 },
  { name: "Gadchiroli", km: 170 },
  { name: "Amravati", km: 155 },
  { name: "Akola", km: 250 },
  { name: "Yavatmal", km: 150 },
  { name: "Buldhana", km: 300 },
  { name: "Washim", km: 230 },
];

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

const DISTRICT_PAGES = DISTRICTS.map((d) => ({
  path: `/coaching/${slugify(d.name)}`,
  district: d.name,
  km: d.km,
  h1: `JEE, NEET & MHT-CET Coaching in Nagpur for ${d.name} Students`,
  title: `JEE / NEET / MHT-CET Coaching in Nagpur for ${d.name} Students | The Rankers Academy`,
  metaDescription: `Students from ${d.name} (Vidarbha) preparing for JEE, NEET or MHT-CET at The Rankers Academy, Nagpur — just ${d.km} km away. Hostel/residential guidance for outstation aspirants. Call ${NAP.phoneDisplay}.`,
  kicker: `For ${d.name} · Vidarbha`,
  intro: [
    `Every year, serious JEE, NEET and MHT-CET aspirants from ${d.name} travel to Nagpur for coaching that their home town can't match. The Rankers Academy — founded by VNIT Nagpur alumni — is about ${d.km} km from ${d.name}, making it a practical choice for ${d.name} families who want IIT/NEET-level teaching with hostel/residential support.`,
    `Our Laxmi Nagar head centre is built for outstation students: a disciplined daily routine, daily micro-tests, direct founder mentorship and guidance on safe nearby accommodation so students from ${d.name} can focus entirely on their rank.`,
  ],
  highlights: [
    `Residential/hostel guidance for outstation students from ${d.name}`,
    "Structured daily routine with daily micro-tests (DMT)",
    "Taught directly by VNIT Nagpur alumni — no junior faculty",
    `Only ~${d.km} km from ${d.name} to our Laxmi Nagar campus`,
  ],
  faqs: [
    { q: `Do you take students from ${d.name}?`, a: `Yes — we regularly mentor outstation students from ${d.name} and across Vidarbha, and help arrange safe hostel/PG accommodation near our Nagpur campus.` },
    { q: `How far is The Rankers Academy from ${d.name}?`, a: `Our Laxmi Nagar, Nagpur campus is approximately ${d.km} km from ${d.name}.` },
    { q: "Is hostel/residential option available?", a: `We provide residential guidance and help ${d.name} families find trusted accommodation near the campus; call ${NAP.phoneDisplay} for current options.` },
  ],
}));

export const SEO_LANDING_PAGES = [...COURSE_PAGES, ...DISTRICT_PAGES];
export const SEO_LANDING_MAP = Object.fromEntries(SEO_LANDING_PAGES.map((p) => [p.path, p]));
export { PROGRAMMES };
